import { array, number, object, string, TypeOf } from 'zod';

/* ------------------------------- Age Rating ------------------------------- */

export const AgeRating = object({
    id: string(),
    ageClassificationId: string(),
    name: string(),
    description: string().optional(),
    age: number().optional(),
    image: string().optional(),
    links: object({
        image: string().optional(),
    }).optional(),
});

export type AgeRating = TypeOf<typeof AgeRating>;

/* ------------------------------ AllAgeRatings ----------------------------- */

export const AllAgeRatings = object({
    data: array(AgeRating),
});

export type AllAgeRatings = TypeOf<typeof AllAgeRatings>;
